export const checkInterval = 30000;
